import { render, staticRenderFns } from "./unhandledList.vue?vue&type=template&id=c5b82f04"
import script from "./unhandledList.vue?vue&type=script&lang=js"
export * from "./unhandledList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports